import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ReactBridge @reactComponent={{this.flashMessages}} />",{ moduleName: "register-partners-js/components/flash-messages.hbs" })